/**
 * Created by nicom on 8/1/2017.
 */

import BackGroundColors from "./BackGroundColors";

class ProjectChartData {
  constructor(data, totalTime) {
    this.Data = data;
    this.totalTime = totalTime;
  }

  GetDataObject() {
    if (this.Data.length === 0) {
      return {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: [],
          },
        ],
      };
    } else {
      const datalabels = [];
      const dataValues = [];

      this.Data.map((projectData) => {
        const workedTime = projectData.WorkedTime;
        if (workedTime !== 0) {
          dataValues.push(Math.round((workedTime / this.totalTime) * 100));
          datalabels.push(
            `${projectData.Employee.Name  } ${  projectData.Employee.LastName}`
          );
        }
        return null;
      });
      const colors = BackGroundColors.getBackGroundColors(dataValues.length);
      return {
        labels: datalabels,
        datasets: [
          {
            backgroundColor: colors,
            data: dataValues,
          },
        ],
      };
    }
  }
}

export default ProjectChartData;
